"use client";
import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(
  "7800ea790f42126d54ee8302b6e74f5eTz0xMzE2MTksRT0xODE3MDc4Mzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTUsQVQ9c2luZ2xlLEtWPTI=",
);

export default function MuiXLicense() {
  return null;
}
